import React, { useEffect, useState } from "react";
import TildeIcon from "../../../assets/images/generico/TildeIcon";
import CruzBlancaIcon from "../../../assets/images/generico/CruzBlancaIcon";
import DarkModeMoon from "../../../assets/images/generico/DarkModeMoon";
import LightModeLamp from "../../../assets/images/generico/LightModeLamp";
import "./BotonToggleStyle.css";

const BotonToggle = ({
  altStr,
  onClickVinculaGoogle,
  facebookVinculado,
  auxFacebook,
  onClickDesvincularGoogle,
  vinculandoGoogle,
  googleVinculado,
  onClickVinculaApple,
  onClickDesvincularApple,
  vinculandoApple,
  appleVinculado,
  toggleTheme,
  wspVinculado,
  onClickAceptaWsp,
  active,
  biometricVinculado
}) => {
  const [animationToggle, setAnimationToggle] = useState([""]);

  const [posicionToggle, setPosicionToggle] = useState([
    "notificacion-boton-desplazar-izquierda",
  ]);
  const [borderColor, setBorderColor] = useState([
    "notificacion-boton-border-color-izquierda",
  ]);

  const seleccionarOpcionToggle = () => {
    if (posicionToggle === "notificacion-boton-desplazar-derecha") {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
      if (altStr === "facebook") {
        setPosicionToggle("notificacion-boton-desplazar-derecha");
        setBorderColor("notificacion-boton-border-color-derecha");
        setAnimationToggle("desplazarDerecha");
      }
      if (altStr === "Google logo") {
        setPosicionToggle("notificacion-boton-desplazar-derecha");
        setBorderColor("notificacion-boton-border-color-derecha");
        setAnimationToggle("desplazarDerecha");
        onClickDesvincularGoogle();
      }
      if (altStr === "Apple logo") {
        setPosicionToggle("notificacion-boton-desplazar-derecha");
        setBorderColor("notificacion-boton-border-color-derecha");
        setAnimationToggle("desplazarDerecha");
        onClickDesvincularApple();
      }
      if (altStr === "Biometric") {
        setPosicionToggle("notificacion-boton-desplazar-derecha");
        setBorderColor("notificacion-boton-border-color-derecha");
        setAnimationToggle("desplazarDerecha");
        onClickDesvincularApple();
      }
      if (altStr === "aceptaWsp") {
        onClickAceptaWsp();
      }
    } else {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
      if (altStr === "Google logo") {
        onClickVinculaGoogle();
        vinculandoGoogle();
      }
      if (altStr === "Apple logo") {
        onClickVinculaApple();
        vinculandoApple();
      }
      if (altStr === "Biometric") {
        onClickVinculaApple();
        vinculandoApple();
      }
      if (altStr === "aceptaWsp") {
        onClickAceptaWsp();
      }
    }
  };

  useEffect(() => {
    if (googleVinculado) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [googleVinculado]);

  useEffect(() => {
    if (appleVinculado) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [appleVinculado]);

  useEffect(() => {
    if (facebookVinculado) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [facebookVinculado]);

  //agregado de facebook para forzar el toggle.
  useEffect(() => {
    if (auxFacebook) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [auxFacebook]);

  useEffect(() => {
    if (wspVinculado) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [wspVinculado]);

  useEffect(() => {
    if (biometricVinculado) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [biometricVinculado]);

  // Hacer active el estado del Togle 
  useEffect(() => {
    if (active) {
      setPosicionToggle("notificacion-boton-desplazar-derecha");
      setBorderColor("notificacion-boton-border-color-derecha");
      setAnimationToggle("desplazarDerecha");
    } else {
      setPosicionToggle("notificacion-boton-desplazar-izquierda");
      setBorderColor("notificacion-boton-border-color-izquierda");
      setAnimationToggle("desplazarIzquierda");
    }
  }, [active]);

  return (
    <React.Fragment>
      <div
        onClick={seleccionarOpcionToggle}
        className={`ptur-card-perfil-body-notificaciones-boton ${borderColor} `}
      >
        <div
          className={`notificacion-boton-circulo ${posicionToggle} ${animationToggle}`}
        >
          <div className={`notificacion-boton-tilde `}>
            {toggleTheme ? (
              posicionToggle === "notificacion-boton-desplazar-izquierda" ? (
                <DarkModeMoon />
              ) : (
                <LightModeLamp />
              )
            ) : posicionToggle === "notificacion-boton-desplazar-izquierda" ? (
              <CruzBlancaIcon color={"bgc-grey65"} />
            ) : (
              <TildeIcon color={"var(--color-broccoli)"} />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BotonToggle;
